import React from "react";
import "./css/ProductProfile.css";
import { useParams  } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SuccessMessage from "../Auth/SuccessMessage";

const ProductProfile = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [currentImage, setCurrentImage] = useState(0);
    const [showSuccess, setShowSuccess] = useState(false);
    const navigate = useNavigate();
    useEffect( () => {
        axios.get(`https://monkeprogrammer01.pythonanywhere.com/products/${id}/`)
        .then((response) => setProduct(response.data))
        .catch((error) => console.error("Ошибка загрузки товара", error));
    }, [id] )

    if (!product) {
        return <p>Загрузка товара...</p>;
    }

    const updateQuantityOnServer = async (action) => {
      const token = localStorage.getItem("access_token");
      const data = {
        product: product.id,
        action: action,
      };
  
      try {
        await axios.post("https://monkeprogrammer01.pythonanywhere.com/products/add/", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        console.log("Error during quantity update:", error);

      }
    };

    const handleSubmit = () => {
      updateQuantityOnServer("add");
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false)
      }, 1500);
    }

    return (
        <div className="product-profile">
          <div className="product-images">
            <div className="product-main-image">
              
              <img
                src={`https://monkeprogrammer01.pythonanywhere.com${product.images[currentImage].image}`}
                alt={product.product_name}
                className="main-image"
              />
            </div>
            <div className="product-thumbnails">
              {product.images.map((image, index) => (
                <img
                  key={index}
                  src={`https://monkeprogrammer01.pythonanywhere.com${image.image}`}
                  alt={`Thumbnail ${index + 1}`}
                  className="thumbnail"
                  onClick={() => setCurrentImage(index)}
                />
              ))}
            </div>
          </div>
    
          <div className="product-details">
            <h1>{product.product_name}</h1>
            <p>{product.product_description}</p>
            <p>Цена: {product.product_price} тг</p>
            <p>Размеры: {product.product_size || 'Не указаны'}</p>

            <button className="btn btn-success" id="buy-button" onClick={() => {updateQuantityOnServer("add") ;navigate("/user")}}>Купить</button>
            <button className="add-to-cart-button" onClick={handleSubmit} >Добавить в корзину</button>
          </div>
          { showSuccess && <SuccessMessage
          onClose={() => setShowSuccess(false)}
          message={"Добавлено в корзину!"}
        />}
        </div>
        
      );
};

export default ProductProfile;
